import {
  confirmSignIn,
  signIn,
  signOut,
  fetchAuthSession,
} from "aws-amplify/auth";
import { IAuthService } from "@entities/IAuthService";
import { AmplifyAuthResponse } from "@entities/AmplifyAuthResponse";

export class AmplifyAuth implements IAuthService {
  async login(
    username: string,
    password: string,
  ): Promise<AmplifyAuthResponse> {
    const { nextStep } = await signIn({
      username,
      password,
      options: {
        authFlowType: "USER_PASSWORD_AUTH",
      },
    });
    const firstStep = nextStep.signInStep;
    if (firstStep !== "CONFIRM_SIGN_IN_WITH_EMAIL_CODE") {
      throw new Error(
        `Passo inesperado: ${firstStep}. O passo esperado é CONFIRM_SIGN_IN_WITH_EMAIL_CODE`,
      );
    }

    return { nextStep };
  }

  async confirmLogin(
    challengeResponse: string,
    signInStep: string,
  ): Promise<AmplifyAuthResponse> {
    if (signInStep !== "CONFIRM_SIGN_IN_WITH_EMAIL_CODE") {
      throw new Error(
        `SignInStep: ${signInStep} é diferente de CONFIRM_SIGN_IN_WITH_EMAIL_CODE`,
      );
    }
    const { nextStep } = await confirmSignIn({
      challengeResponse,
    });

    const secondStep = nextStep.signInStep;

    if (secondStep !== "DONE") {
      throw new Error(`SignInStep: ${secondStep} diferente de DONE`);
    }
    const tokens = await this.getAuthTokens();

    return { nextStep, tokens };
  }

  async getAuthTokens(forceRefresh = false) {
    const session = await fetchAuthSession({ forceRefresh });
    return {
      accessToken: session.tokens?.accessToken?.toString() || "",
      idToken: session.tokens?.idToken?.toString() || "",
    };
  }

  async signOut(): Promise<void> {
    await signOut();
  }
}
